import { SiteUrls } from '@tableau/shared-urls';
import { DataGrid } from '@tableau/widgets-datagrid';
import * as _ from 'underscore';

import { CommonDataGridColumns } from '../../common/react/CommonDataGridColumns';
import { IActionTarget } from '../../common/react/components/ActionsMenu';
import { DataGridCells } from '../../common/react/components/dataGrid/DataGridCells';
import { SortableHeader } from '../../common/react/components/dataGrid/SortableHeader';
import { IReactTranslateService } from '../../common/react/IReactTranslateService';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { FlowListItemInfo } from '../../ts/models/FlowInfo';
import { IActionButton } from '../../ts/services/ActionPanelService';

export type FlowGridScope = CommonDataGridColumns.ISelectColumnScope<FlowListItemInfo> &
  CommonDataGridColumns.IFavoriteColumnScope<FlowListItemInfo>;

export module FlowsGrid {
  export function columns(
    scope: FlowGridScope,
    translate: IReactTranslateService,
    actions: IActionButton<FlowListItemInfo, {}>[],
    getActionTarget: () => IActionTarget<FlowListItemInfo, {}>,
    siteUrls: SiteUrls)
    : DataGrid.Column[] {

    const selectedColumn = CommonDataGridColumns.selected(scope);

    const nameColumn: DataGrid.Column = CommonDataGridColumns.withExtraSpace(
      CommonDataGridColumns.withActions(
        {
          name: 'name-col',
          dataKey: 'name',
          headerText: translate('column_name'),
          direction: 'asc',
          headerFormatter: SortableHeader.Formatter(),
          cellFormatter: DataGridCells.Link((row: DataGrid.Row) => {
            return {
              text: row.data.name,
              url: siteUrls.flowUrl(row.data.id),
              iconClassName: 'tb-grid-icon-flow',
              iconTitle: translate('flow')
            };
          })
        },
        {
          actions,
          translate,
          getActionTarget,
        },
        scope
      )
    );

    const projectNameColumn: DataGrid.Column = {
      name: 'project-name-col',
      dataKey: 'projectName',
      headerText: translate('column_project'),
      direction: 'asc',
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.Link((row: DataGrid.Row) => {
        return {
          text: row.data.project.name,
          url: siteUrls.projectUrl(row.data.project.id)
        };
      })
    };

    const ownerColumn = CommonDataGridColumns.owner(translate, siteUrls);

    const updatedAtColumn: DataGrid.Column = {
      name: 'updated-at-col',
      dataKey: 'updatedAt',
      headerText: translate('column_updated'),
      direction: 'desc',
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.DateTimeCell('updatedAt')
    };

    return _.compact([
      selectedColumn,
      FeatureFlags.flowFavoritesEnabled ? CommonDataGridColumns.favorite(scope) : null,
      nameColumn,
      projectNameColumn,
      ownerColumn,
      updatedAtColumn
    ]);
  }
}
